// extracted by mini-css-extract-plugin
export var lightMode = "_h-0";